import { PlaybookVariable } from 'src/services/api/playbooks/use-playbook-variables';

export const getValidPlaybookVariables = ({
    variables,
    isNewLeadPlaybook,
}: {
    variables: PlaybookVariable[];
    isNewLeadPlaybook: boolean;
}) => {
    const validPlaybookVariables = [];

    // Always show lead first name (if the backend also supports it)
    if (variables.includes(PlaybookVariable.LeadFirstName)) {
        validPlaybookVariables.push(PlaybookVariable.LeadFirstName);
    }

    // Show property address only if it's a new lead playbook,
    if (variables.includes(PlaybookVariable.PropertyAddress)) {
        if (isNewLeadPlaybook) {
            validPlaybookVariables.push(PlaybookVariable.PropertyAddress);
        }
    }

    // Show tour link only if it's a new lead playbook
    if (variables.includes(PlaybookVariable.PropertyTourLink)) {
        if (isNewLeadPlaybook) {
            validPlaybookVariables.push(PlaybookVariable.PropertyTourLink);
        }
    }

    // Show application link only if it's a new lead playbook
    if (variables.includes(PlaybookVariable.PropertyApplicationLink)) {
        if (isNewLeadPlaybook) {
            validPlaybookVariables.push(PlaybookVariable.PropertyApplicationLink);
        }
    }

    return validPlaybookVariables;
};

export const getValidPlaybookVariablesV2 = (variables: PlaybookVariable[]) => {
    return [
        PlaybookVariable.LeadFirstName,
        PlaybookVariable.PropertyAddress,
        PlaybookVariable.PropertyTourLink,
        PlaybookVariable.PropertyApplicationLink,
        PlaybookVariable.ReviewLink,
        PlaybookVariable.NumberOfBathrooms,
        PlaybookVariable.NumberOfBedrooms,
        PlaybookVariable.Rent,
        PlaybookVariable.SMSSignature,
        PlaybookVariable.EmailSignature,
        PlaybookVariable.YourName,
        PlaybookVariable.YourFirstName
    ].filter(variable => {
        return variables.includes(variable);
    });
};
